import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { ClientPaymentSettingService } from '../services/client_payment_setting.service'
import { APIPaymentSettingClientDtoResponse } from '../types/api'
import { defaultQueryOptions } from './common'

export const useClientPaymentSettings = (
  locationName: string,
  options: { locationBookingSurcharge: string; enabled?: boolean } = { locationBookingSurcharge: '' }
): UseQueryResult<APIPaymentSettingClientDtoResponse> => {
  const { locationBookingSurcharge, enabled = true } = options
  return useQuery<APIPaymentSettingClientDtoResponse>({
    queryKey: ['clientPaymentSettings', locationName, locationBookingSurcharge],
    queryFn: () => ClientPaymentSettingService.list(locationName, { locationBookingSurcharge }),
    enabled: enabled && Boolean(locationName && locationBookingSurcharge),
    ...defaultQueryOptions,
  })
}
